<template>
  <b-card title="Update Auth Token Settings">
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-form @submit.prevent="updateAuthTokenSetting">
        <b-row>
          <b-col md="6">
            <b-card
              title="Secure Dual-Token Mode"
              class="mb-1 h-100"
            >
              <b-form-radio-group
                id="auth-token-enabled"
                v-model="form.enabled"
                :options="enabledOptions"
                value-field="item"
                text-field="name"
                :disabled="!canEdit"
              />
            </b-card>
          </b-col>

          <b-col
            v-if="form.enabled"
            md="6"
          >
            <b-card
              title="Access Token Duration"
              class="mb-1 h-100"
            >
              <b-form-group
                label="Duration (minutes)"
                label-for="access-ttl"
                class="mb-0"
              >
                <b-form-input
                  id="access-ttl"
                  v-model.number="form.access_token_ttl_minutes"
                  type="number"
                  min="1"
                  max="52560000"
                  style="max-width: 220px"
                  :disabled="!canEdit"
                />
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <div class="ml-2">
            <strong>Off:</strong> legacy single bearer token.
            <br>
            <strong>On:</strong> short-lived access token. Set the duration on the right.
            <template v-if="form.enabled">
              <br>
              Access token duration applies after the next login.
            </template>
          </div>
        </b-row>

        <b-row class="mt-1">
          <b-col class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              :disabled="!canEdit || loading"
            >
              Save Changes
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BOverlay, BForm, BRow, BCol, BFormGroup, BFormRadioGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const AuthTokenSettingRepository = RepositoryFactory.get('authTokenSetting')

export default {
  components: {
    BCard,
    BOverlay,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      form: {
        enabled: false,
        access_token_ttl_minutes: 15,
      },
      enabledOptions: [
        { item: true, name: 'On' },
        { item: false, name: 'Off' },
      ],
    }
  },
  computed: {
    canEdit() {
      return this.$can('password-rest')
    },
  },
  mounted() {
    this.fetchSetting()
  },
  methods: {
    async fetchSetting() {
      this.loading = true
      try {
        const { data } = (await AuthTokenSettingRepository.getAuthTokenSetting()).data
        this.form = {
          enabled: Boolean(data.enabled),
          access_token_ttl_minutes: Number(data.access_token_ttl_minutes) || 15,
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async updateAuthTokenSetting() {
      this.loading = true
      try {
        const { data } = (await AuthTokenSettingRepository.updateAuthTokenSetting({
          enabled: Boolean(this.form.enabled),
          access_token_ttl_minutes: Number(this.form.access_token_ttl_minutes),
        })).data
        this.form = {
          enabled: Boolean(data.enabled),
          access_token_ttl_minutes: Number(data.access_token_ttl_minutes),
        }
        this.showSuccessMessage('Auth Token Settings Updated Successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
  },
}
</script>
